/**
 * Type definitions for testing
 */

export type TestIdProp = {
  /**
   * The test id which is assigned to the "data-test-id" attribute of an element on render.
   * Used for test automation.
   */
  testId?: string
}

/**
 * transform function for components to render testId as data-test-id in DOM
 * Usage example: <button {...testIdProp(props)} />
 */
export const testIdProp = ({ testId }: TestIdProp): any =>
  testId === undefined
    ? {}
    : {
        "data-test-id": testId
      }
